import { Row, Card, Button, message, Space } from 'antd';
import { useState, useMemo } from 'react';
import LoaderComponent from '../../Loader';
import CustomText from '../../CustomText';
import API from '../../../services/API';

function StripeCards({
  userId,
  refreshData,
  stripeCards = [],
  loading,
}) {
  const [primaryLoading, setPrimaryLoading] = useState(false);

  // Sort cards so primary is first
  const sortedCards = useMemo(() => stripeCards.toSorted((a, b) => {
    if (a.isPrimary) return -1;
    if (b.isPrimary) return 1;
    return 0;
  }), [stripeCards]);

  const deleteCard = async (cardId) => {
    if (window.confirm('Are you sure you want to delete this card?')) {
      try {
        await API.deleteStripeCard({ userId, cardId});
        message.success('Successfully deleted the card.');
        await refreshData();
      } catch (error) {
        message.error('Failed to delete the card.');
      }
    }
  }  
  
  const setPrimary = async (cardId) => {
    try {
      setPrimaryLoading(true);
      await API.setStripePrimaryCard(userId, cardId);
      message.success('Successfully set card as primary.');
      await refreshData();
    } catch (error) {
      message.error('Failed to set card as primary.');
      console.error('Failed to set primary stripe card: ', error)
    }
    setPrimaryLoading(false)
  }

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Card bordered={false} className="criclebox tablespace mb-16">
            <div className="ant-list-box trans table-responsive">
              <table className="width-100">
                <thead>
                  <tr>
                    <th>Billing Name</th>
                    <th>Billing Zip</th>
                    <th>Card Brand</th>
                    <th>Last Four</th>
                    <th>Card Funding</th>
                    <th>Finger Print</th>
                    <th>Expiry</th>
                    <th>Addr line-1 Check</th>
                    <th>Addr Zip Check</th>
                    <th>Card Cvc Check</th>
                    <th>Card Country</th>
                    <th>Three Ds Supported</th>
                    <th>Primary</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedCards && sortedCards.length > 0 ? (
                    sortedCards.map((data) => {
                      return (
                        <tr className={data.isPrimary ? "active-row" : ""}>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'billingName'}
                            />
                          </td>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'billingZip'}
                            />
                          </td>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'cardBrand'}
                            />
                          </td>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'last4'}
                            />
                          </td>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'cardFunding'}
                            />
                          </td>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'fingerprint'} />
                          </td>
                          <td>
                            <CustomText
                              dataSet={{ ...data }}
                              property1={'expMonth'}
                              property2={'expYear'}
                              seperator={'/'}
                            />
                          </td>
                          {/* je */}
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'addrLineOneCheck'} />
                          </td>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'addrZipCheck'} />
                          </td>
                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'cardCvcCheck'} />
                          </td>

                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'cardCountry'} />
                          </td>

                          <td>
                            <CustomText
                              dataSet={data}
                              property1={'threeDsSupported'} />
                          </td>
                          <td>
                            {data.isPrimary ? 'Yes' : 'No'}
                          </td>
                          <td>
                            <Space>
                              <Button type="danger" onClick={() => deleteCard(data.cardId)} style={{ marginLeft: "auto" }}>
                                Delete Card
                              </Button>
                              {data.isPrimary === false &&
                                <Button onClick={() => setPrimary(data.cardId)} style={{ marginLeft: "auto" }} loading={primaryLoading}>
                                  Set Primary
                                </Button>}
                            </Space>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="12" align="center">
                        <Row className="no-data-card">No Data Found</Row>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card>
        </>
      )}
    </>
  );
}

export default StripeCards;
